import { z } from 'zod';

export const CardUpdateStateSchema = z.object({
    id: z.string().optional(),
    index: z.number(),
    active: z.boolean(),
    revealed: z.boolean(),
    rotation: z.number(),
    flip: z.boolean(),
    zoom: z.boolean(),
    revealProgress: z.number(),
    interactive: z.boolean().optional(),
});

// UpdateCard messages are patches, so they may include only the fields that changed.
export const CardUpdatePatchSchema = CardUpdateStateSchema.partial();

export type CardUpdateState = z.infer<typeof CardUpdateStateSchema>;
export type CardUpdatePatch = z.infer<typeof CardUpdatePatchSchema>;
